/**
 * @generated SignedSource<<7042c4b5f8ece0146037a042866232d2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type instantBuyOpenSpaceMutation$variables = {
  lineItemId: string;
};
export type instantBuyOpenSpaceMutation$data = {
  readonly lineItemRetrieve: {
    readonly id: string;
  };
};
export type instantBuyOpenSpaceMutation = {
  response: instantBuyOpenSpaceMutation$data;
  variables: instantBuyOpenSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lineItemId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "lineItemId",
            "variableName": "lineItemId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UnlockRequest",
    "kind": "LinkedField",
    "name": "lineItemRetrieve",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "instantBuyOpenSpaceMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "instantBuyOpenSpaceMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "cc9d767e2efa574a23921f7cba21bc28",
    "id": null,
    "metadata": {},
    "name": "instantBuyOpenSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation instantBuyOpenSpaceMutation(\n  $lineItemId: UUID!\n) {\n  lineItemRetrieve(input: {lineItemId: $lineItemId}) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "845277690c47d2b7017fed331069c6e6";

export default node;
